<template>
  <div class="header bg-white d-flex justify-content-end align-items-center position-fixed pb-3">


    <svg @click="toggleSidebar" class="dashboard-collapser" :class="{ collapsed: sidebarCollapsed }" width="21"
      height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g opacity="0.6">
        <path
          d="M10.5 20C7.99712 20 6.22052 19.9975 4.87305 19.8164C3.55429 19.6391 2.79719 19.307 2.24512 18.7549C1.69304 18.2028 1.3609 17.4457 1.18359 16.127C1.00248 14.7795 1 13.0029 1 10.5C1 7.99712 1.00248 6.22052 1.1836 4.87305C1.3609 3.55429 1.69304 2.79719 2.24512 2.24512C2.79719 1.69304 3.55429 1.36089 4.87305 1.18359C6.22052 1.00248 7.99712 0.999999 10.5 0.999999C13.0029 0.999999 14.7795 1.00248 16.127 1.18359C17.4457 1.3609 18.2028 1.69304 18.7549 2.24512C19.307 2.79719 19.6391 3.55429 19.8164 4.87305C19.9975 6.22052 20 7.99712 20 10.5C20 13.0029 19.9975 14.7795 19.8164 16.127C19.6391 17.4457 19.307 18.2028 18.7549 18.7549C18.2028 19.307 17.4457 19.6391 16.127 19.8164C14.7795 19.9975 13.0029 20 10.5 20Z"
          stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
        <path d="M7.18433 21L7.18433 9.53674e-07" stroke="black" stroke-width="2" />
      </g>
    </svg>

    <!-- <div class="">
      <b-icon icon="bell" class="icon rounded"></b-icon>
      <b-badge class="badge rounded-circle">4</b-badge>
    </div> -->

    <div v-if="user" class="user-detail d-flex align-items-center gap-3">
      <LanguageFlagDropdown class="mr-3" />
      <NotificationHeader :bellIcon="'black'" />
      <b-dropdown id="dropdown-right" right class="dropdown header-section-dropdown mr-2 mr-sm-0">
        <template slot="button-content">
          <b-img v-if="user.team_member && user.team_member.profile_picture" class="userSmallImage rounded-circle"
            :src="user.team_member.profile_picture"></b-img>
          <div v-else class="user-default-img">
            {{ user.first_name.charAt(0).toUpperCase() }}{{ user.last_name.charAt(0).toUpperCase() }}
          </div>
        </template>
        <b-dropdown-item>
          <div class="d-flex flex-column"><span class="font-weight-bold f-14">{{ user.first_name }} {{ user.last_name
          }}</span>
            <span class="f-12">{{ user.email }}</span>
          </div>
        </b-dropdown-item>
        <hr class="my-2" />
        <!-- <b-dropdown-item to="/profile-page"><span class="f-14">{{ $t('header.viewProfile') }}</span></b-dropdown-item> -->
        <b-dropdown-item v-if="!isGeotabAddin" to="/all-companies"><span class="f-14">{{ $t('header.viewCompanies')
        }}</span></b-dropdown-item>
        <hr class="my-2" v-if="!isGeotabAddin" />
        <b-dropdown-item @click="OnlogoutUser"><span class="f-14">{{ $t('header.logout') }}</span></b-dropdown-item>
      </b-dropdown>
    </div>
    <ReferralSection />
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import NotificationHeader from "../Shared/NotificationHeader.vue";
import ReferralSection from "@/components/ReferralSection";
import { clearGleapUser } from "@/plugins/gleap";
import { SUPPORTED_LOCALES, setLocale } from "@/i18n";
import LanguageFlagDropdown from "@/components/Shared/LanguageFlagDropdown.vue";
export default {
  name: "Header",
  components: { NotificationHeader, ReferralSection, LanguageFlagDropdown },
  data() {
    return {
      supportedLocales: SUPPORTED_LOCALES,
    };
  },
  computed: {
    ...mapGetters(["user", 'appVersion', 'userNotifications', 'company', 'isGeotabAddin', 'sidebarCollapsed']),
    currentLocale() {
      return this.$i18n.locale;
    },
  },
  methods: {
    ...mapActions(["logoutUser", "getUserByID", "createUserLogs", "toggleSidebar"]),
    changeLocale(code) {
      setLocale(code);
    },
    async OnlogoutUser() {
      await this.createUserLogs({ action: 'logout' });
      this.logoutUser();
      if (!process.env.VUE_APP_SHOW_INTERCOM) {
        clearGleapUser();
      }
      this.$router.push(`/login${this.isGeotabAddin ? '?geotabAddin=true' : ''}`);
    },
  },
  async mounted() {
    await this.getUserByID();
  },
};
</script>

<style>
.update-notification-dot {
  position: absolute;
  top: -2px;
  right: -5px;
}

.header-section-dropdown .dropdown-toggle {
  display: flex;
  align-items: center;
}

.userSmallImage {
  width: 35px;
  height: 35px;
  border: 2px solid #FAFAFA;
  object-fit: cover;
}

.user-default-img {
  width: 35px;
  height: 35px;
  background-color: #2cce89;
  border: 2px solid #FAFAFA;
  color: white;
  display: flex;
  font-weight: 700;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
}

.user-default-img-profile-section {
  width: 100px;
  height: 100px;
  font-size: 20px;
}

.header {
  padding: 10px 0;
  position: absolute;
  left: 0;
  right: 0;
  z-index: 1;
  background: #fff;
  border: 1px solid #dee2e6;
  z-index: 6;
}

.icon {
  width: 22px;
  height: 25px;
  font-size: 24px;
  color: var(--black);
  cursor: pointer;
}

.b-icon.icon :not(svg) {
  color: #000000;
}

.badge {
  font-size: 10px !important;
  height: 17px;
  width: 17px;
  background-color: var(--btn-bg-color);
  position: relative;
  top: -13px !important;
  left: -11px;
  padding: 3px !important;
  line-height: 11px !important;
}

#dropdown-right button {
  background-color: transparent !important;
  color: var(--black) !important;
  font-weight: 600;
  font-size: var(--small);
  border: unset;
  border: none !important;
}

#dropdown-right .dropdown-toggle::after {
  margin-left: 10px;
}

.dropdown-menu {
  margin-top: 5px !important;
}

.notification-dropdown>button::after {
  border: 0 !important;
}

.notification-dropdown .dropdown-menu {
  margin-top: 5px !important;
  width: 430px;
  transform: translate3d(-310px, 25px, 0px) !important;
  padding: 0;
  border-radius: 0.25rem;
}

.notification-details-section {
  width: 300px;
}

.notification-header-section {
  background-color: #F5F5F5;
  border-radius: 0.25rem 0.25rem 0rem 0rem !important;
}

.dashboard-collapser {
  position: absolute;
  left: 253px;
  cursor: pointer;
  transition: left 0.5s ease;
}

.dashboard-collapser.collapsed {
  left: 90px;
}
@media (max-width: 575px) {
  .dashboard-collapser, .dashboard-collapser.collapsed{
    left: 10px;
  }
}

/* @media (max-width: 575px) {
  .btn-group > .btn,
  .btn-group-vertical > .btn {
    padding: 0 !important;
  }
} */
/* @media(max-width: 370px){
    .user-detail{
        width: min-content;
    }
} */</style>
